import { render, staticRenderFns } from "./OcrHistory.vue?vue&type=template&id=4441c8c8&scoped=true&"
import script from "./OcrHistory.vue?vue&type=script&lang=js&"
export * from "./OcrHistory.vue?vue&type=script&lang=js&"
import style0 from "./OcrHistory.vue?vue&type=style&index=0&id=4441c8c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4441c8c8",
  null
  
)

export default component.exports